// Supervisor-requested pickup banner.
//
// Fires when a supervisor flags a delivered take for re-record. The banner is
// the ONLY red element in the actor UI besides hard failures — pickup demands
// attention. It includes the supervisor's name, optional note (in quotes), and
// the keyboard hint to start the pickup.
/**
 * Banner shown at the top of the recording UI when a pickup has been
 * requested. Recording the pickup increments the take version (v++).
 *
 * @param supervisorName display name of the requesting supervisor
 * @param note           optional free-text note from the supervisor; rendered
 *                       inside quotes so it cannot be confused with system copy
 */
export function pickupBanner(supervisorName, note) {
    if (note && note.trim().length > 0) {
        const cleaned = note.trim();
        return {
            icon: '🔴',
            zh: `🔴 ${supervisorName} 请你补录\n\n"${cleaned}"\n\n按 Enter / R 开始(版本 → v++)`,
            en: `🔴 ${supervisorName} requested a pickup\n\n"${cleaned}"\n\nPress Enter / R to start (version → v++)`,
            es: `🔴 ${supervisorName} solicitó un pickup\n\n"${cleaned}"\n\nPulse Enter / R para empezar (versión → v++)`,
        };
    }
    return {
        icon: '🔴',
        zh: `🔴 ${supervisorName} 请你补录此条。按 Enter / R 开始(版本 → v++)。`,
        en: `🔴 ${supervisorName} requested a pickup on this cue. Press Enter / R to start (version → v++).`,
        es: `🔴 ${supervisorName} solicitó un pickup de esta toma. Pulse Enter / R para empezar (versión → v++).`,
    };
}
/**
 * Compact one-line variant used inside cue-list rows (no note, no keyboard
 * hint, no newlines).
 */
export function pickupRowLabel(supervisorName) {
    return {
        icon: '🔴',
        zh: `${supervisorName} 请补录`,
        en: `${supervisorName} requested pickup`,
        es: `${supervisorName} solicitó pickup`,
    };
}
